module.exports = __webpack_public_path__ + "static/media/rpvideo.283d2e06.webm";